import Record from "./base"
import { getStateCodeByStateName } from "us-state-codes"
import countryList from "country-list"

const c = countryList()

export class Location extends Record {
  get label() {
    return this.getLabel()
  }
  getLabel() {
    if (this.country === "United States") {
      return `${this.city}, ${getStateCodeByStateName(this.state)}`
    } else {
      return `${this.city}, ${c.getCode(this.country)}`
    }
  }
}
